export const LOCATION_DETAILS = [
  {
    label: 'จังหวัด',
    value: [['room', 'location', 'province']],
  },
  {
    label: 'สถานที่/หน่วยงาน (ภาษาไทย)',
    value: [['room', 'location', 'nameTh']],
  },
  {
    label: 'สถานที่/หน่วยงาน (ภาษาอังกฤษ)',
    value: [['room', 'location', 'nameEn']],
  },
  {
    label: 'อาคาร',
    value: [['room', 'location', 'building']],
  },
];

export const ROOM_INFORMATION = [
  {
    label: 'ชั้น',
    value: [['room', 'floor']],
  },
  {
    label: 'ชื่อห้อง',
    value: [['room', 'name']],
  },
  {
    label: 'เลขห้อง',
    value: [['room', 'roomNumber']],
  },
  {
    label: 'จำนวนที่นั่ง',
    value: [['room', 'seatCount']],
  },
];
